import React from "react";
import Invoices from "../../Invoices/Invoices";

const Invoicesdiv = () => {
  return (
    <div>
      <Invoices />
    </div>
  );
};

export default Invoicesdiv;
